import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import ResctrictedAccessSVG from 'images/restrictedAccess.svg';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { translate } from 'containers/services/translate';
import messages from 'containers/ErrorPage/messages';
import { BUTTON_COLORS } from 'constants/design';
import mailBoxIcon from 'images/mail-box.svg';
import callIcon from 'images/call-icon.svg';
import styled from 'styled-components';
import { useHealthCheck } from 'hooks/useHealthCheck';

export interface ErrorPageProps {
  intl: IntlShape;
}

const ButtonContainer = styled.div`
  .title-button {
    margin-left: 5px;
    color: #1175c9;
    text-transform: lowercase;
  }
  .title-button-secondary {
    margin-left: 5px;
    color: #ffffff;
  }
`;

const ErrorPage: React.FC<ErrorPageProps> = (props): JSX.Element => {
  const { refresh } = useHealthCheck(50000);
  const handleRefresh = () => {
    window.location.reload();
    refresh();
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <img src={ResctrictedAccessSVG} width="20%" alt="restricted" />
      <div
        style={{
          fontSize: '40px',
          fontWeight: 'bold',
          margin: '30px',
          textAlign: 'center',
        }}
      >
        {translate({ ...messages.errorTitlePage }, props)}
        <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#727A83' }}>
          {translate({ ...messages.errorDescriptionPage }, props)}
        </div>
        <ButtonContainer>
          <a href="mailto:servicedesk@sanlamallianz.ma">
            <PrimaryButton
              title={translate({ ...messages.mailServiceDesk }, props)}
              background={BUTTON_COLORS.BLUE_BUTTON_TITLE}
              lefticon={<img src={mailBoxIcon} alt="mailBox" />}
              border={BUTTON_COLORS.PRIMARY_BLUE}
              titleclass="title-button"
              style={{ width: '100%', height: '100%' }}
            />
          </a>
          <div style={{ margin: '5px' }}>
            <PrimaryButton
              title={translate({ ...messages.telServiceDesk }, props)}
              background={BUTTON_COLORS.PRIMARY_BLUE}
              lefticon={<img src={callIcon} alt="CallIcon" />}
              border={BUTTON_COLORS.PRIMARY_BLUE}
              titleclass="title-button-secondary"
              style={{ width: '100%', height: '100%' }}
            />
          </div>
          <div style={{ margin: '5px' }}>
            <PrimaryButton
              title={translate({ ...messages.refreshTitle }, props)}
              background={BUTTON_COLORS.PRIMARY_BLUE}
              border={BUTTON_COLORS.PRIMARY_BLUE}
              titleclass="title-button-secondary"
              style={{ width: '100%', height: '100%' }}
              onClick={() => handleRefresh()}
            />
          </div>
        </ButtonContainer>
      </div>
    </div>
  );
};

export default injectIntl(ErrorPage);

export interface ErrorPageProps {
  intl: IntlShape;
}
